/*
Alex Sartori
HMC

*/
// import { dlResults, dlUrl, kwResults, kwUrl, brResults, brUrl } from "../_helpers/sampleResults"; // uncomment if you want to test
import { getJsonData } from "./getJsonData";
import { loggerStyle } from "./loggerStyle";
import {
  getTexts,
  getTranslation,
  getBooleanStorefront,
} from "./translations";
import {
  errorsMsg,
  type,
  node,
  classes,
  attributes,
  iconFA,
  time,
  tagging,
  _hmcObject,
  BRAND,
} from "./hmcConfig";
import { gigyaGetAccountInfo } from "./gigya";
import { settings } from "./settings";
import { setPageVisibility, isNextPageVisible } from "./pageVisibility";
import { printCTA } from "./configurator";
import { isEmptyObj, isSmartedit, getBaseApiPath } from "./utils";
import { log } from "./logger";
import {
  registrationTemplate,
  formSendEvent,
  anchorEvent,
  forcePrintRegistationForm,
} from "./registrationForm";
import { getLocalStorageItemName } from "./localStorage";
import "../css/hmc.scss";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowRotateRight,
  faAngleRight,
  faAngleLeft,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCircle,
  faCircleDot,
} from "@fortawesome/free-regular-svg-icons";
import {
  onCompletedShowProductsDL,
  onCompletedShowProductsKW,
  onCompletedShowProductsBR
} from "./expression";
import { renderLandingPopUp } from "./landingPopUp";
import { ls } from "./localStorage";
(function (window) {
  "use strict";

  library.add(faArrowRotateRight, faAngleLeft, faAngleRight, faCheck, faCircle, faCircleDot);
  dom.watch();

  function DlgHMC() {

    function logTimer(name, type = time.START, force = false) {
      if (settings.debug || force) time._(name, type);
    }

    function renderRegistrationForm() {
      if (!((settings.registrationForm || forcePrintRegistationForm()) && !settings.app.registrationForm)) {
        return;
      }

      settings.app.registrationForm = addChild(
        document.getElementById(settings.app.root),
        "div",
        {
          class: classes.registration.element,
        }
      );
      addChild(settings.app.registrationForm, "div", {
        class: classes.registration.image,
        style: "",
      });
      settings.app.registrationFormWrapper = addChild(
        settings.app.registrationForm,
        "div",
        {
          class: classes.registration.wrapper,
        },
        registrationTemplate()
      );

      formSendEvent();
      anchorEvent();
    }

    _hmcObject.printRegistrationForm = () => {
      renderRegistrationForm();
      gigyaGetAccountInfo();
    };

    async function builder(force = false) {
      //document.body.innerHTML = getSurveyHeader();
      //await translations;
      if (force) document.getElementById(settings.app.root).innerHTML = "";
      if (!force) {
        document.getElementById(settings.app.root).style.display = "none";
        document
          .getElementById(settings.app.root)
          .classList.add("theme-" + settings.brand);
        if (settings.themeLight)
          document
            .getElementById(settings.app.root)
            .classList.add("themeLight");
      }

      settings.app.wrapper = addChild(
        document.getElementById(settings.app.root),
        "div",
        {
          class: "hmc-app__wrapper",
        }
      );
      var restart = createElementHMC(
        "div",
        {
          id: classes.header.restartTop,
          class: classes.header.restartTop,
        },
        printIconFA(
          "fa-solid fa-arrow-rotate-right",
          getTranslation("hmc.header.restartTop"),
          iconFA.icon.text.space.single,
          iconFA.icon.text.position.after
        )
      );
      prependElement(settings.app.wrapper, restart);
      restart.addEventListener("click", restartHMC);
      renderHeader();
      renderNavigation();
      settings.currentPage = 0;
      settings.previousPage = 0;

      renderPages();

      if (localStorage.getItem(getLocalStorageItemName())) {
        log("[HMC] Go back to last results", false, true);
        if (window.location.hash === "#/results") {
          settings.answersMap = JSON.parse(
            localStorage.getItem(getLocalStorageItemName())
          );
          for (let i = 0; i < settings.pagesMap.length; i++) {
            const element = settings.pagesMap[i];
            if (element.length > 1) {
              for (let k = 0; k < element.length; k++) {
                const el = element[k];
                if (settings.answersMap[el].length > 0) {
                  setAnswersNavigationTitle({
                    question: el,
                    answers: settings.answersMap[el],
                    page: i,
                  });
                }
              }
            } else {
              setAnswersNavigationTitle({
                question: element[0],
                answers: settings.answersMap[element[0]],
                page: i,
              });
            }
          }
          settings.currentPage = settings.form[node.PAGES].length;
          surveyCompleted(true);
        } else {
          localStorage.removeItem(getLocalStorageItemName());
          localStorage.removeItem(ls.getKeyLeadForm());
          renderLandingPopUp();
        }
      } else {
        renderLandingPopUp();
      }
      goToPage(settings.currentPage, settings.currentPage);

      document.getElementById(settings.app.root).classList.add("app-ready");
      document.getElementById(settings.app.root).removeAttribute("style");
    }

    function renderHeader() {
      settings.app.header = addChild(settings.app.wrapper, "div", {
        class: classes.header.element,
      });
      var title = addChild(
        settings.app.header,
        "div",
        {
          class: classes.header.title,
        },
        getTranslation("hmc.header.title")
      );
    }

    function renderResultsPage(number = false) {
      if (number) {
        settings.app.resultsWrapper = addChild(settings.app.wrapper, "div", {
          id: "hmc-page-" + number,
          class: "hmc-page",
        });
        addChild(
          settings.app.resultsWrapper,
          "div",
          {
            id: "hmc-result__info",
            class: "hmc-page__info",
          },
          getTranslation("hmc.results.selectProduct")
        );
        settings.app.results = addChild(settings.app.resultsWrapper, "div", {
          id: "hmc-results",
          class:
            "hmc-results hmc-page " +
            (settings.brand == BRAND.kenwood
              ? "ken-plp__content"
              : "del-plp-wrapper"),
        });
      }
    }

    function printIconFA(
      className,
      text = false,
      space = false,
      where = false
    ) {
      var afterText = "",
        beforeText = "";
      if (space) {
        afterText = space + afterText;
        beforeText = beforeText + space;
      }
      if (text) {
        afterText = afterText + text;
        beforeText = text + beforeText;
      }
      where === iconFA.icon.text.position.after
        ? (beforeText = "")
        : (afterText = "");

      return beforeText + '<i class="' + className + '"></i>' + afterText;
    }

    function renderNextButton() {
      if (!settings.navigationLight) {
        settings.app.navBtns = addChild(
          document.getElementById(settings.app.root),
          "div",
          {
            class: classes.navigation.app,
          }
        );
        settings.app.prevBtn = addChild(
          settings.app.navBtns,
          "button",
          {
            id: "hmc-app__navigation__btn--prev",
            class: "hmc-app__navigation__btn--prev" + " disabled",
          },
          printIconFA(
            "fa-solid fa-angle-left",
            getTranslation("hmc.prev"),
            iconFA.icon.text.space.double,
            iconFA.icon.text.position.after
          )
        );
        settings.app.nextBtn = addChild(
          settings.app.navBtns,
          "button",
          {
            id: "hmc-app__navigation__btn--next",
            class: "hmc-app__navigation__btn--next" + " disabled",
          },

          printIconFA(
            "fa-solid fa-angle-right",
            getTranslation("hmc.next"),
            iconFA.icon.text.space.double,
            iconFA.icon.text.position.before
          )
        );
        document
          .getElementById("hmc-app__navigation__btn--next")
          .addEventListener("click", goToNextPage);
        document
          .getElementById("hmc-app__navigation__btn--prev")
          .addEventListener("click", goToPreviousPage);
      }
      if (settings.navigationDL) {
        renderNextButtonDL();
      }
    }

    function renderNextButtonDL() {
      settings.app.navBtns = addChild(
        document.getElementById(settings.app.root),
        "div",
        {
          class:
            classes.navigation.app +
            " " +
            classes.navigation.app +
            "--delonghi",
        }
      );
      settings.app.prevBtn = addChild(
        settings.app.navBtns,
        "div",
        {
          class: classes.navigation.app + "--delonghi__text",
        },
        getTranslation("hmc.navigation.text")
      );
      settings.app.nextBtn = addChild(
        settings.app.navBtns,
        "button",
        {
          id: "hmc-app__navigation__btn--next",
          class: "hmc-app__navigation__btn--next" + " disabled",
        },
        getTranslation("hmc.next")
      );
      document
        .getElementById("hmc-app__navigation__btn--next")
        .addEventListener("click", goToNextPage);
    }

    function controlNextButton(answers, maxAnswers = 1, minAnswers = 1) {
      log("CONTROLLO NEXT");
      log(answers);
      log(maxAnswers);
      log(minAnswers);
      if (answers === 0 || minAnswers > answers) {
        disableNextButton();
        settings.isAnswered = false;
      } else if (answers >= minAnswers && maxAnswers >= answers) {
        activeNextButton();
        settings.isAnswered = true;
        if (settings.navigationLight && !isDLNavigationVisible())
          goToNextPage();
      }
      //settings.app.nextBtn.classList.remove(classes.btn.disabled);
    }

    function isDLNavigationVisible() {
      if (settings.navigationDL && settings.navigationDLisVisible) return true;
      return false;
    }

    function activeNextButton() {
      log("CONTROLLO NEXT: active");
      if (!settings.navigationLight || settings.navigationDL)
        settings.app.nextBtn.classList.remove(classes.btn.disabled);
    }

    function disableNextButton() {
      log("CONTROLLO NEXT: disabled");
      if (!settings.navigationLight || settings.navigationDL)
        settings.app.nextBtn.classList.add(classes.btn.disabled);
    }

    function activePrevButton() {
      if (!settings.navigationLight)
        settings.app.prevBtn.classList.remove(classes.btn.disabled);
    }

    function disablePrevButton() {
      if (!settings.navigationLight)
        settings.app.prevBtn.classList.add(classes.btn.disabled);
    }

    function renderPages() {
      var pages = settings.form[node.PAGES];
      pages.forEach((page, pn) => {
        setPageVisibility(page, pn);
        var q = getPageElements(page);
        settings.app.page = addChild(settings.app.wrapper, "div", {
          id: "hmc-page-" + pn,
          class: "hmc-page",
          data: { page: pn },
        });
        log(
          "Page[" +
          pn +
          "] has " +
          q.length +
          " question" +
          (q.length > 1 ? "s" : ""),
          loggerStyle.blue
        );
        q.forEach((element, i) => {
          renderQuestion(element, pn, i);
        });
      });
      if (settings.hmc.inPageResults) {
        renderResultsPage(pages.length);
      }
      renderNextButton();
      loadingSpinnerOff();
      return false;
    }

    function renderQuestion(
      question,
      pageNumber = false,
      questionNumber = false
    ) {
      _hmcObject.log("renderQuestion");
      _hmcObject.log(question);
      settings.answersMap[question[node.NAME]] = [];
      settings.questionsMap[question[node.NAME]] = {
        title: question[node.TITLE],
        page: pageNumber,
        answers: {},
      };
      if (!settings.pagesMap[pageNumber]) settings.pagesMap[pageNumber] = [];
      settings.pagesMap[pageNumber].push(question[node.NAME]);
      var options = question[node.CHOICES];
      var isVisibleIf = question[node.VISIBLEIF]
        ? question[node.VISIBLEIF]
        : false;
      if (isVisibleIf)
        setVisibleIfMap(question[node.NAME], isVisibleIf, pageNumber);
      _hmcObject.log(options.length);
      var pageQuestionWrapper = addChild(
        document.getElementById("hmc-page-" + pageNumber),
        "div",
        {
          id: "hmc-page__wrapper__" + question[node.NAME],
          class:
            "hmc-page__question-wrapper" +
            (isVisibleIf ? " hidden" : "") +
            (isMultiSelect(question) > 1 ? " hmc-page__question-wrapper__is-game" : ""),
          data: {
            visibleif: isVisibleIf,
          },
        }
      );
      var pageInfo = addChild(
        pageQuestionWrapper,
        "div",
        {
          id: "hmc-page-" + pageNumber + "__info__" + question[node.NAME],
          class: "hmc-page__info",
        },
        getLocaleText(getTranslation("hmc.page.info.text"), {
          number: isMultiSelect(question),
        },
          question,
        )
      );

      var questionsWrapper = addChild(pageQuestionWrapper, "div", {
        class:
          "dlquestion-wrapper answer-wrapper" +
          (isMultiSelect(question) > 1 ? " dlquestion-wrapper__is-game" : ""),
        id: "hmc-page-" + pageNumber + "__question-" + questionNumber,
        data: {
          page: pageNumber,
          question: questionNumber,
          qname: question[node.NAME],
          minSelectedChoices: isMinSelect(question),
          maxSelectedChoices: isMaxSelect(question),
        },
      });
      options.forEach((option) => {
        var slide = addChild(questionsWrapper, "div", {
          class: "dlquestion-slide",
          data: {
            answer: option.value,
            question: questionNumber,
            page: pageNumber,
            qname: question[node.NAME],
          },
        });
        var optionDescription = option.imageDescription
          ? option.imageDescription
          : false;

        var slideImage = addChild(slide, "div", {
          class: "dlquestion-slide__image",
          data: {
            answer: option.value,
            question: questionNumber,
            page: pageNumber,
            qname: question[node.NAME],
          },
          style: createWrapperBG(option),
        });

        var slideContent = addChild(slide, "div", {
          class:
            "dlquestion-slide__content" +
            (optionDescription ? " dlquestion-content__with-description" : ""),
          data: {
            answer: option.value,
            question: questionNumber,
            page: pageNumber,
            qname: question[node.NAME],
          },
        });

        var slideImage = addChild(
          slide,
          "div",
          {
            class: " dlquestion-slide" + (
              isMultiSelect(question) > 1 ? "__checkbox" : "__arrow"
            ),
            data: {
              answer: option.value,
              question: questionNumber,
              page: pageNumber,
              qname: question[node.NAME],
            },
          },
          isMultiSelect(question) > 1
            ? `<div class="checkbox-square"></div>`
            : (settings.brand === BRAND.delonghi
              ? printIconFA("fa-solid fa-angle-right")
              : (`<div class="radio-circle">${printIconFA("fa-regular fa-circle")}${printIconFA("fa-regular fa-circle-dot")}</div>`)
            )
        );

        var optionText = option.text;
        if (question[node.TYPE] === type.IMAGEPICKER) {
          if (!question.showLabel) optionText = "";
        }

        var slideContentText = addChild(
          slideContent,
          "span",
          {
            class: "dlquestion-content--text",
            data: {
              answer: option.value,
              question: questionNumber,
              page: pageNumber,
              qname: question[node.NAME],
            },
          },
          optionText
        );
        if (optionDescription) {
          addChild(
            slideContent,
            "span",
            {
              class: "dlquestion-content--description",
              data: {
                answer: option.value,
                question: questionNumber,
                page: pageNumber,
                qname: question[node.NAME],
              },
            },
            optionDescription
          );
        }
        settings.questionsMap[question[node.NAME]].answers[option.value] =
          optionText;

        slide.addEventListener(
          "click",
          function () {
            clickOnSlide(slide);
          },
          false
        );
      });

      return question[node.TITLE];
    }

    function splitCondition(exp, delimiter = "anyof") {
      var test = exp.match(/^{(.*)}\s(anyof|=)\s([\[|\'].*[\]|\'+])$/);
      log(test);
      if (test.length > 1) {
        var testSingleValue = test[3].match(/^'.*'$/);
        if (!!testSingleValue) {
          test[3] = "[" + test[3] + "]";
        }
        return [test[1], JSON.parse(test[3].replace(/'/g, '"')), test[2]];
      }
      return false;
    }

    function splitConditionOrAnd(exp, q) {
      var orCond = " or ";
      var andCond = " and ";
      var a = exp.split(orCond);
      var arr = [{ active: q }];

      for (let i = 0; i < a.length; i++) {
        const element = a[i];
        log("Sto lavorando su: " + element);
        const res = splitCondition(element);
        if (res) {
          arr.push({
            name: res[0],
            operator: res[2],
            values: res[1],
          });
        }
      }

      settings.visibleIfMapForCheckingAll.push(arr);
    }

    function setVisibleIfMap(q, condition, page = false) {
      var questionToWatch = "",
        withValues = "";
      var test = splitCondition(condition);
      if (test) {
        //ok è anyof!
        withValues = test[1];
        questionToWatch = test[0];
        if (!settings.visibleIfMap[questionToWatch]) {
          settings.visibleIfMap[questionToWatch] = [
            { values: test[1], active: q, operator: test[2], page: page },
          ];
        } else {
          settings.visibleIfMap[questionToWatch].push({
            values: withValues,
            active: q,
            operator: test[2],
            page: page,
          });
        }
      }

      splitConditionOrAnd(condition, q);
    }

    function createWrapperBG(option) {
      if (option[node.IMAGE]) {
        return " background-image: url(" + option[node.IMAGE] + ")";
      }
      return "";
    }

    function isMultiSelect(q) {
      //maxSelectedChoices
      //multiSelect
      var t = 1;
      switch (q[node.TYPE]) {
        case type.IMAGEPICKER:
          if (q[node.MULTISELECT]) {
            t = howManySelection(q);
          }
          break;
        case type.CHECKBOX:
          if (q[node.MAXSELECTEDCHOICES]) {
            t = howManySelection(q);
          }
          break;
        default:
          break;
      }
      return t;
    }

    function howManySelection(q) {
      if (q[node.MAXSELECTEDCHOICES]) {
        return q[node.MAXSELECTEDCHOICES];
      } else {
        return 2;
      }
    }

    function isMinSelect(q) {
      var t = 1;
      switch (q[node.TYPE]) {
        case type.IMAGEPICKER:
          if (q[node.MINSELECTEDCHOICES] && q[node.MULTISELECT]) {
            t = q[node.MINSELECTEDCHOICES];
          }
          break;
        case type.CHECKBOX:
          break;
        default:
          break;
      }
      return t;
    }

    function isMaxSelect(q) {
      var t = 1;
      switch (q[node.TYPE]) {
        case type.IMAGEPICKER:
          if (q[node.MAXSELECTEDCHOICES] && q[node.MULTISELECT]) {
            t = q[node.MAXSELECTEDCHOICES];
          }
          break;
        case type.CHECKBOX:
          break;
        default:
          break;
      }
      return t;
    }

    function clickOnSlide(el) {
      var element = el;
      log(el);
      if (element.classList.contains(classes.slide.text))
        element = el.target.parentNode;
      if (element.tagName == "svg") element = el.target.parentNode;
      if (element.tagName == "path") element = el.target.parentNode.parentNode;

      settings.currentQuestion =
        element.attributes[attributes.data.QUESTION_NAME].nodeValue;

      settings.question.answer.max = getMaxSelected(
        element.attributes[attributes.data.QUESTION].nodeValue,
        element.attributes[attributes.data.PAGE].nodeValue
      );
      settings.question.answer.min = getMinSelected(
        element.attributes[attributes.data.QUESTION].nodeValue,
        element.attributes[attributes.data.PAGE].nodeValue
      );

      if (element.classList.contains(classes.slide.selected)) {
        removeClass(element, classes.slide.selected);
        // qui rimuovere risposte dal array
        log("REMOVEEEEEEEEEEE: ");
        settings.currentAnswer = settings.currentAnswer.filter(
          (item) =>
            item !== element.attributes[attributes.data.ANSWER].nodeValue
        );
        settings.answersMap[
          element.attributes[attributes.data.QUESTION_NAME].nodeValue
        ] = settings.answersMap[
          element.attributes[attributes.data.QUESTION_NAME].nodeValue
        ].filter(
          (item) =>
            item !== element.attributes[attributes.data.ANSWER].nodeValue
        );
      } else {
        if (settings.question.answer.max > settings.currentAnswer.length) {
          addClass(element, classes.slide.selected);
          settings.currentAnswer.push(
            element.attributes[attributes.data.ANSWER].nodeValue
          );
          settings.answersMap[
            element.attributes[attributes.data.QUESTION_NAME].nodeValue
          ] = settings.currentAnswer;
        } else {
          //max selected is be reach
          if (settings.question.answer.max == 1) {
            settings.currentAnswer = [];
            settings.answersMap[
              element.attributes[attributes.data.QUESTION_NAME].nodeValue
            ] = [];
            var selectedSlides = document.querySelectorAll(
              "#hmc-page-" + settings.currentPage + " .answer-wrapper .selected"
            );
            for (let i = 0; i < selectedSlides.length; i++) {
              const element = selectedSlides[i];
              removeClass(element, classes.slide.selected);
            }
            addClass(element, classes.slide.selected);
            settings.currentAnswer.push(
              element.attributes[attributes.data.ANSWER].nodeValue
            );
            settings.answersMap[
              element.attributes[attributes.data.QUESTION_NAME].nodeValue
            ].push(element.attributes[attributes.data.ANSWER].nodeValue);
          } else {
            hmcAlert(getTranslation("hmc.maxSelected"), {
              number: settings.question.answer.max,
            });
          }
        }
      }
      log(settings.currentAnswer);
      controlNextButton(
        settings.currentAnswer.length,
        settings.question.answer.max,
        settings.question.answer.min
      );
    }

    function getMaxSelected(q, p = 0) {
      var max = document.getElementById(
        classes.page + "-" + p + "__" + classes.question + "-" + q
      ).attributes[attributes.data.MAXSELECTEDCHOICES].nodeValue;
      return parseInt(max);
    }

    function getMinSelected(q, p = 0) {
      var min = document.getElementById(
        classes.page + "-" + p + "__" + classes.question + "-" + q
      ).attributes[attributes.data.MINSELECTEDCHOICES].nodeValue;
      return parseInt(min);
    }

    function getPageElements(page) {
      return page[node.ELEMENTS];
    }

    function getPageTitle(number, page) {
      if (page[node.TITLE]) {
        return renderPageTitle(number + 1, page[node.TITLE]);
      } else {
        return renderPageTitleFromQuestion(number + 1, page[node.ELEMENTS][0]);
      }
    }

    function getResultsTitle() {
      return getTranslation("hmc.results.title");
    }

    function getQuestionTitle(element) {
      var t = "";
      switch (element[node.TYPE]) {
        case type.RADIOGROUP:
        case type.IMAGEPICKER:
          log(element[node.TYPE]);
          t = element[node.TITLE];
          break;
        case type.CHECKBOX:
          t = element[node.NAME];
          break;
        default:
          break;
      }
      return t;
    }

    function renderPageTitle(number, title) {
      _hmcObject.log("(" + number + ") " + title);
      return [number, title];
    }

    function renderPageTitleFromQuestion(number, element) {
      _hmcObject.log(number);
      var title = getQuestionTitle(element);
      _hmcObject.log("(" + number + ") " + title);
      return [number, title];
    }

    function renderNavigation() {
      var pages = getPages();
      var result = "";
      if (settings.themeLight)
        settings.app.navigationTitle = addChild(settings.app.wrapper, "div", {
          class: "hmc-navigation__titles",
        });

      settings.app.navigation = addChild(settings.app.wrapper, "div", {
        class: "hmc-navigation",
      });

      if (pages) {
        pages.forEach((element, i) => {
          addNavigationItem(element, i);
        });
        if (settings.hmc.inPageResults) {
          addNavigationItem(true, pages.length, true);
        }
      }
      return result;
    }

    function addNavigationItem(element, i, isResults = false) {
      var item = addChild(settings.app.navigation, "div", {
        id: "hmc-navigation__page-" + i,
        class: "hmc-navigation__page",
        data: { page: i },
      });
      //item.addEventListener("click", goToPageFromNavigation, false);
      if (isResults) {
        var n = i + 1;
        var t = getResultsTitle();
      } else {
        var [n, t] = getPageTitle(i, element);
      }
      if (!settings.themeLight) {
        addChild(
          item,
          "span",
          {
            class: "hmc-navigation__page--number",
          },
          n
        );
        addChild(
          item,
          "div",
          {
            class: "hmc-navigation__page--title",
          },
          renderNavigationPageTitle(t, n)
        );
      } else {
        addChild(
          settings.app.navigationTitle,
          "div",
          {
            id: "hmc-navigation__title-" + i,
            class: "hmc-navigation__title",
            data: { page: i },
          },
          t
        );
        addChild(
          item,
          "span",
          {
            class: "hmc-navigation__page--number",
          },
          ""
        );
      }
    }

    function renderNavigationPageTitle(text, number) {
      return `<span class="hmc-navigation__page--title__question">${text}</span><span id="hmc-navigation__page--answer-page-${number - 1
        }" class="hmc-navigation__page--answer"></span>`;
    }

    function goToNextPage() {
      log(settings.isAnswered);
      if (settings.isAnswered === true) {
        dataLayerPush(tagging.event.action.step, {
          step: settings.currentPage + 1,
          question: settings.currentQuestion,
          answers: settings.currentAnswer,
        });
        setAnswersNavigationTitle({
          question: settings.currentQuestion,
          answers: settings.currentAnswer,
          page: settings.currentPage,
        });
        settings.answers.push(settings.currentAnswer);
        settings.currentAnswer = [];
        if (settings.currentPage + 1 < settings.lastPage) {
          checkVisibleIfForAllQuestions();
          goToPage(settings.currentPage + 1, settings.currentPage);
        } else {
          if (settings.hmc.inPageResults)
            goToPage(settings.currentPage + 1, settings.currentPage);
        }
        settings.isAnswered = false;
      } else {
        hmcAlert(getTranslation("hmc.minSelected"), {
          number: settings.question.answer.min,
        });
      }
    }

    function setAnswersNavigationTitle(data = {}) {
      if (!settings.themeLight) {
        var text = "";
        var toolTip = "";
        var toolTipEl = "";
        var overCount = 0;
        data.answers.forEach((element, i) => {
          if (i > 0 && text.length > 50) {
            overCount++;
            toolTip += settings.questionsMap[data.question].answers[element];
            if (i < data.answers.length - 1) toolTip += "<br>";
          } else {
            text += settings.questionsMap[data.question].answers[element];
            toolTip += settings.questionsMap[data.question].answers[element];
            if (i < data.answers.length - 1) text += ", ";
            if (i < data.answers.length - 1) toolTip += "<br>";
          }
        });
        log(text);
        if (overCount > 0) {
          text += "+" + overCount;
          toolTipEl =
            '<span class="hmc-navigation__page--answer__tooltip">' +
            toolTip +
            "</span>";
        }
        document.getElementById(
          "hmc-navigation__page--answer-page-" + data.page
        ).innerHTML = text + toolTipEl;
      }
    }

    function checkVisibleIfForAllQuestions() {
      var found = false;
      var array = settings.visibleIfMapForCheckingAll;
      settings.qToActivate = {};
      for (let i = 0; i < array.length; i++) {
        const element = array[i];
        const toActivate = element[0].active;
        for (let k = 1; k < element.length; k++) {
          const arr = element[k];
          const q = arr.name;
          found = false;
          log("CHECK VISIBILITY " + arr.name);
          switch (arr.operator) {
            case "anyof":
              if (settings.answersMap[q].length > 0) {
                found = settings.answersMap[q].every((ai) =>
                  arr.values.includes(ai)
                );
                if (found) {
                  //showQuestion(toActivate);
                  if (!settings.qToActivate[q]) settings.qToActivate[q] = [];
                  settings.qToActivate[q].push({
                    q: toActivate,
                    o: arr.operator,
                  });
                }
              }
              break;
            case "=":
              if (
                settings.answersMap[q].length > 0 &&
                settings.answersMap[q].length == arr.values.length
              ) {
                found = settings.answersMap[q].every((ai) =>
                  arr.values.includes(ai)
                );
                log("log", loggerStyle.big.greenOnYellow);
                log(settings.answersMap[q]);
                log(arr.values);
                if (found) {
                  //questionToActivate = arr.active;
                  //showQuestion(toActivate);
                  if (!settings.qToActivate[q]) settings.qToActivate[q] = [];
                  settings.qToActivate[q].push({
                    q: toActivate,
                    o: arr.operator,
                  });
                }
              }
              break;
            default:
              break;
          }
        }
      }
      showQuestion();
    }

    function showQuestion() {
      if (!!settings.qToActivate[settings.currentQuestion]) {
        var qToA = settings.qToActivate[settings.currentQuestion];
        var foundEquals = { found: false, question: false };
        log(qToA);
        for (let i = 0; i < qToA.length; i++) {
          const element = qToA[i];
          if (element.o == "=") {
            foundEquals.found = true;
            foundEquals.question = element.q;
          }
        }
        if (foundEquals.found) {
          showQuestionByName(foundEquals.question);
        } else {
          showQuestionByName(qToA[0].q);
        }
      }
    }

    function showQuestionByName(qname = false) {
      if (qname) {
        log(qname + " is showing...", loggerStyle.lightgreen);
        document
          .getElementById("hmc-page__wrapper__" + qname)
          .classList.remove("hidden");
      }
    }

    function goToPreviousPage(event) {
      if (settings.currentPage == 0) return;
      checkVisibleIfForAllQuestions();
      resetVisibilityQuestionsFromPage(settings.currentPage);
      // settings.currentAnswer = settings.answersMap[]
      resetAnswersFromPage(settings.currentPage);
      const currentQ = getCurrentQuestionNameByPage(settings.previousPage);
      settings.currentAnswer = settings.answersMap[currentQ];
      settings.isAnswered = true;
      goToPage(settings.previousPage);
      activeNextButton();
    }

    function getCurrentQuestionNameByPage(page) {
      for (let i = 0; i < settings.pagesMap[page].length; i++) {
        const question = settings.pagesMap[page][i];
        const qEl = document.getElementById("hmc-page__wrapper__" + question);
        if (!qEl.classList.contains("hidden")) {
          settings.currentQuestion = question;
          return question;
        }
      }
    }

    function resetVisibilityQuestionsFromPage(fromPage) {
      for (let i = fromPage; i < settings.pagesMap.length; i++) {
        const element = settings.pagesMap[i];
        for (let k = 0; k < element.length; k++) {
          const questionName = element[k];
          const questionPage = document.getElementById(
            "hmc-page__wrapper__" + questionName
          );
          if (questionPage.dataset.visibleif != "false") {
            questionPage.classList.add("hidden");
            log("hiding " + questionName + "...", loggerStyle.lightgreen);
          }
        }
      }
    }

    function resetAnswersFromPage(fromPage) {
      log("reset answers from page: " + fromPage);
      if (!settings.themeLight) {
        document.getElementById(
          "hmc-navigation__page--answer-page-" + fromPage
        ).innerHTML = "";
        document.getElementById(
          "hmc-navigation__page--answer-page-" + (fromPage - 1)
        ).innerHTML = "";
      }
      for (let i = fromPage; i < settings.pagesMap.length - 1; i++) {
        const element = settings.pagesMap[i];
        for (let k = 0; k < element.length; k++) {
          const questionName = element[k];
          settings.answersMap[questionName] = [];
        }
      }
      const selectedAnswers = document.querySelectorAll(
        "#hmc-page-" + fromPage + " .answer-wrapper.selected"
      );
      for (let j = 0; j < selectedAnswers.length; j++) {
        const element = selectedAnswers[j];
        removeClass(element, classes.slide.selected);
        log("has been deselected answer n." + j + " of page " + fromPage);
        log(element);
      }
    }

    function goToPage(n = 0, previousPage = 0) {
      _hmcObject.log("Trying go to page " + n);
      if (isNextPageVisible(n)) {
        for (let i = 0; i < settings.pagesMap.length + 1; i++) {
          if (i < n) {
            document
              .getElementById(classes.page + "-" + i)
              .classList.remove("active");
            document
              .getElementById(classes.navigation.page + "-" + i)
              .classList.add("visited");
            document
              .getElementById(classes.navigation.page + "-" + i)
              .classList.remove("active");
            if (settings.themeLight)
              document
                .getElementById(classes.navigation.title + "-" + i)
                .classList.remove("active");
          }
          if (i == n) {
            document
              .getElementById(classes.page + "-" + i)
              .classList.add("active");
            document
              .getElementById(classes.navigation.page + "-" + i)
              .classList.add("active");
            document
              .getElementById(classes.navigation.page + "-" + i)
              .classList.remove("visited");
            if (settings.themeLight)
              document
                .getElementById(classes.navigation.title + "-" + i)
                .classList.add("active");
          }
          if (i > n) {
            document
              .getElementById(classes.page + "-" + i)
              .classList.remove("active");
            document
              .getElementById(classes.navigation.page + "-" + i)
              .classList.remove("visited");
            document
              .getElementById(classes.navigation.page + "-" + i)
              .classList.remove("active");
            if (settings.themeLight)
              document
                .getElementById(classes.navigation.title + "-" + i)
                .classList.remove("active");
          }
        }
        activateNavigationDL(n);
        disableNextButton();
        disablePrevButton();
        if (n > 0) {
          if (settings.brand === BRAND.delonghi) scrollToTop();
          if (settings.brand === BRAND.kenwood) scrollToTop(getAppHeight());
          activePrevButton();
        }
        settings.currentPage = n;
        settings.previousPage = previousPage;
        if (settings.currentPage === settings.lastPage) surveyCompleted();
      } else {
        goToPage(n + 1, previousPage);
      }
    }

    function activateNavigationDL(i) {
      log("activateNavigationDL");
      if (settings.navigationDL) {
        log(
          "#" + classes.page + "-" + i + " .hmc-page__question-wrapper__is-game"
        );
        if (
          document.querySelector(
            "#" +
            classes.page +
            "-" +
            i +
            " .hmc-page__question-wrapper__is-game"
          ) ||
          false
        ) {
          document
            .querySelector("." + classes.navigation.app + "--delonghi")
            .classList.add("visible");
          settings.navigationDLisVisible = true;
        } else {
          document
            .querySelector("." + classes.navigation.app + "--delonghi")
            .classList.remove("visible");
          settings.navigationDLisVisible = false;
        }
      }
    }

    function renderResults(url, reloaded) {
      let apiUrl = url;

      if (settings.form[node.ONCOMPLETED.CATEGORYURL]) {
        apiUrl = settings.form[node.ONCOMPLETED.CATEGORYURL] + url;
      }

      if (settings.form[node.ONCOMPLETED.CATEGORYIDENTIFIER]) {
        const baseApiPath = getBaseApiPath(settings.form[node.ONCOMPLETED.CATEGORYIDENTIFIER]);
        apiUrl = baseApiPath + url;
      }

      loadDoc(apiUrl, reloaded);
    }

    function reorderProductsBasedOnQuery(htmlString, queryUrl) {
      const queryParams = queryUrl.split('?q=');
      if (queryParams.length < 2) {
        return htmlString;
      }

      let domSelector = '';
      let productOrder = '';
      if (settings.brand === BRAND.delonghi) {
        domSelector = '.del-product-box';
        productOrder = queryParams[1].split('baseProduct:').filter(t => /^(?!:)/.test(t)).map(t => t.split(':')[0]);
      } else if (settings.brand === BRAND.kenwood) {
        domSelector = '.ken-product-tile';
        productOrder = queryParams[1].split('?').filter(code => code.trim() !== '');
      } else if (settings.brand === BRAND.braun) {
        domSelector = '.bra-prodTile';
        productOrder = queryParams[1].split('%20').filter(code => code.trim() !== '');
      }
      if (domSelector === '' || productOrder === '') {
        return htmlString;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const productsDom = Array.from(doc.querySelectorAll(domSelector));
      const container = document.createElement('div');

      let founds = 0;
      productOrder.forEach(productName => {
        let foundIndex = -1;
        if (settings.brand === BRAND.delonghi || settings.brand === BRAND.kenwood) {
          foundIndex = productsDom.findIndex(productHtml => productHtml.innerText.indexOf(productName) !== -1);
        } else if (settings.brand === BRAND.braun) {
          //
        }
        if (foundIndex !== -1) {
          founds += 1;
          container.appendChild(productsDom[foundIndex]);
        }
      });

      if (founds !== productsDom.length) { // not all elements found!
        return htmlString;
      }

      return container.innerHTML;
    }

    function loadDoc(url, reloaded) {
      var xhttp = new XMLHttpRequest();

      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && (settings.test || this.status == 200)) {
          let responseText = this.responseText;
          let query = url;

          if (settings.test) {
            if (settings.brand === BRAND.delonghi) {
              responseText = dlResults;
              query = dlUrl;
            } else if (settings.brand === BRAND.kenwood) {
              responseText = kwResults;
              query = kwUrl;
            } else if (settings.brand === BRAND.braun) {
              responseText = brResults;
              query = brUrl;
            }
          }

          //REORDER
          settings.app.results.innerHTML = reorderProductsBasedOnQuery(responseText, query);

          //REMOVE OUT OF STOCK
          if (settings.brand === BRAND.delonghi) {
            document.querySelectorAll('[data-product-dimension1="outOfStock"]').forEach(e => {
              const productBox = e.closest('.del-product-box');
              if (productBox) {
                productBox.remove();
              }
            });
          } else if (settings.brand === BRAND.kenwood) {
            document.querySelectorAll('.--out-of-stock').forEach(e => {
              e.remove();
            });
          } else if (settings.brand === BRAND.braun) {
            document.querySelectorAll('[data-product-dimension1="outOfStock"]').forEach(e => {
              const productBox = e.closest('.bra-prodTile');
              if (productBox) {
                productBox.remove();
              }
            });
          }

          // //REMOVE MORE THAN 3
          // let selector = '';
          // if (settings.brand === BRAND.delonghi) selector = '.del-product-box';
          // if (settings.brand === BRAND.kenwood) selector = '.ken-product-tile'; 
          // if (settings.brand === BRAND.braun) selector = '.bra-prodTile';
          // document.querySelectorAll(selector).forEach((e, i) => {
          //   if (i > 2) {
          //     e.remove();
          //   }
          // });

          //PERFECT CHOICE
          if (settings.brand == BRAND.kenwood) {
            var perfectHtml = "<span>" + getTranslation("hmc.results.perfect") + "</span></div>";
            appendElement(
              document.querySelector(settings.brand == BRAND.kenwood ? ".ken-product-tile__image" : ".del-product-box__image"),
              createElementHMC("div", { class: "hmc-results__perfect" }, perfectHtml)
            );
            document.querySelector(".ken-product-tile").classList.add("perfect");
          } else if (settings.brand == BRAND.braun) {
            settings.app.results.classList.add("braun");
            var firstBraunTile = document.querySelector(".bra-prodTile");
            if (firstBraunTile) {
              var perfectHtml = "<span>" + getTranslation("hmc.results.perfect") + "</span>";
              appendElement(
                firstBraunTile.querySelector(".bra-prodTile__imgWrap"),
                createElementHMC("div", { class: "hmc-results__perfect" }, perfectHtml)
              );
              firstBraunTile.classList.add("perfect");
            }
          }

          printCTA();
          loadLazyImages();
          showResultsOnPage();
          saveProducts();
          renderRegistrationForm();
          gigyaGetAccountInfo();
          if (!reloaded) {
            dataLayerPush(tagging.event.action.end, {
              label: settings.configuratorProducts || [],
            });
          }
        }
      };

      xhttp.open("GET", url, true);
      xhttp.send();
    }


    function saveProducts() {
      var result = [];
      var products = [];

      if (settings.brand === BRAND.kenwood) {
        products = document.querySelectorAll(
          ".hmc-results .js-listing__productTile section[class$=__ctas]"
        );
      } else if (settings.brand === BRAND.delonghi) {
        products = document.querySelectorAll(".del-product-box__cta-wrapper");
      } else if (settings.brand === BRAND.braun) {
        products = document.querySelectorAll(".bra-prodTile");
      }

      for (var i = 0; i < Math.min(products.length, 3); i++) {
        var productElement = products[i];

        var productCodeElement = productElement.querySelector("[data-product-code]");
        if (productCodeElement) {
          result.push(productCodeElement.dataset.productCode);
        }

        var addToCartButton = productElement.querySelector(".js-cart-add");
        if (addToCartButton) {
          addEventListenerOnHMCAddToCart(addToCartButton);
        }

        addEventListenerOnHMCproductClick(productElement);
      }

      settings.configuratorProducts = result;
    }


    function addEventListenerOnHMCAddToCart(el) {
      el.addEventListener("click", function () {
        dataLayerPush(tagging.event.action.addToCart, {
          label: [el.dataset.productCode],
        });
      });
    }

    function addEventListenerOnHMCproductClick(el) {
      el.addEventListener("click", function () {
        dataLayerPush(tagging.event.action.productClick, {
          label: [el.dataset.productCode],
        });
      });
    }

    function showResultsOnPage() {
      printAnchorRegistrationForm();
      settings.app.results.classList.add("active");
      settings.app.page.style = "display:none";
      settings.app.navBtns.classList.add(classes.btn.end);
    }

    function printAnchorRegistrationForm() {
      if (
        (settings.registrationForm || forcePrintRegistationForm())
      ) {
        settings.app.results.insertAdjacentElement(
          "beforebegin",
          createElementHMC(
            "div",
            { id: "hmc-results-anchor" },
            `<div class="hmc-results-anchor__title">${getTranslation(
              "hmc.registration.form.anchor.title"
            )}</div>
             <div class="hmc-results-anchor__subtitle">${getTranslation(
              "hmc.registration.form.anchor.subtitle"
            )}</div>`
          )
        );
      };
      if (document.querySelectorAll('#hmc-results-anchor').length > 1) {
        document.querySelectorAll('#hmc-results-anchor')[1].style.display = 'none'
      }
    }

    function loadLazyImages() {
      const LAZY_PICTURE = "js-lazy-picture";
      var lazyImages = [].slice.call(
        document.querySelectorAll(".lazy-picture")
      );

      if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              const { isIntersecting, target } = entry;
              if (isIntersecting) {
                observer.unobserve(target);
                target.classList.remove(LAZY_PICTURE);
                const sources = Array.from(target.querySelectorAll("source"));
                const img = target.querySelector("img");
                sources.forEach((source) => {
                  source.srcset = source.dataset.lazySrcset;
                  delete source.dataset.lazySrcset;
                });
                img.src = img.dataset.lazySrc;
                delete img.dataset.lazySrc;
              }
            }
          });
        });

        lazyImages.forEach(function (lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      }
    }

    function restartHMC() {
      settings.answers = [];
      settings.answersMap = {};
      settings.visibleIfMap = {};
      settings.visibleIfMapForCheckingAll = [];
      settings.currentAnswer = [];
      settings.questionsMap = {};
      settings.pagesMap = [];
      settings.pageVisibleIf = [];
      settings.app.registrationForm = null;
      if (settings.hmc.isAdvanced) {
        window.location.hash = "";
        localStorage.removeItem(getLocalStorageItemName());
        localStorage.removeItem(ls.getKeyLeadForm());
      }
      if (!settings.navigationLight)
        settings.app.navBtns.classList.remove(classes.btn.end);
      settings.app.wrapper.classList.remove(classes.results.page);
      builder(true);
    }

    function surveyCompleted(reloaded = false) {
      log("SURVEY COMPLETED");
      settings.app.wrapper.classList.add(classes.results.page);
      if (!settings.navigationLight)
        settings.app.navBtns.classList.add(classes.btn.end);
      if (settings.form[node.ONCOMPLETED.SHOWPRODUCTS]) {
        if (settings.hmc.inPageResults) {
          onCompletedShowProducts(true, reloaded);
        } else {
          onCompletedGoToURL();
        }
        if (settings.hmc.isAdvanced) {
          localStorage.setItem(
            getLocalStorageItemName(),
            JSON.stringify(settings.answersMap)
          );
          window.location.hash = "/results";
        }
      }
    }

    function onCompletedGoToURL() {
      for (let i = 0; i < settings.form[node.ONCOMPLETED.GOTOURL].length; i++) {
        const obj = settings.form[node.ONCOMPLETED.GOTOURL][i];
        log(obj, loggerStyle.lightgreen);
        const cond = splitCondition(obj.expression);
        if (cond) {
          if (settings.answersMap[cond[0]].length > 0) {
            const isMatching = settings.answersMap[cond[0]].filter(
              (item) => item !== cond[1]
            );
            if (isMatching) {
              redirectTo(obj.url, "?q=%3Arelevance%3AinStockFlag%3Atrue");
              log("Redirecting...", loggerStyle.big.greenOnYellow);
              return true;
            }
          }
        }
      }
    }

    function onCompletedShowProducts(samePage = false, reloaded = false) {
      let res = "";
      if (settings.brand == BRAND.kenwood) res = onCompletedShowProductsKW();
      if (settings.brand == BRAND.delonghi) res = onCompletedShowProductsDL();
      if (settings.brand == BRAND.braun) res = onCompletedShowProductsBR();
      if (samePage) {
        renderResults("/results" + setQueryStringForResults(res), reloaded);
      } else {
        redirectTo(
          settings.form[node.ONCOMPLETED.CATEGORYURL],
          setQueryStringForResults(res)
        );
      }
    }

    function setQueryStringForResults(s) {
      if (settings.form[node.ONCOMPLETED.PRODUCTSLIST])
        return getQueryStringForFacets(s);
      return getQueryStringForFilter(s);
    }

    function getQueryStringForFilter(s) {
      var q = "?q=";
      var d = " ";
      var skus = s.split(",");
      for (let i = 0; i < skus.length; i++) {
        const el = skus[i];
        q += el + d;
      }
      return q;
    }

    function getQueryStringForFacets(s) {
      var q = "?q=:relevance";
      var d = ":";
      var c = "baseProduct";
      if (settings.form[node.ONCOMPLETED.PRODUCTSTYPELIST])
        c =
          settings.form[node.ONCOMPLETED.PRODUCTSTYPELIST] == "sku"
            ? "code"
            : "baseProduct";
      var codes = s.split(",");
      for (let i = 0; i < codes.length; i++) {
        const el = codes[i];
        q += d + c + d + el;
      }
      return q;
    }

    function redirectTo(url, queryString = "") {
      window.location.href = url + queryString;
    }

    function addClass(el, className) {
      el.classList.add(className);
    }

    function removeClass(el, className) {
      el.classList.remove(className);
    }

    function addChild(parent, tn, attrs, html = false) {
      var e = createElementHMC(tn, attrs, html);
      parent.appendChild(e);
      if (html) e.innerHTML = html;
      return e;
    }

    function prependElement(p, newEl) {
      p.insertAdjacentElement("afterbegin", newEl);
    }

    function appendElement(p, e) {
      p.insertAdjacentElement("afterend", e);
    }

    function createElementHMC(tn, attrs, html = false) {
      var e = document.createElement(tn);
      if (attrs) {
        for (var attr in attrs) {
          if (attr == "data") {
            for (var data in attrs[attr]) {
              e.setAttribute("data-" + data, attrs[attr][data]);
            }
          } else {
            e.setAttribute(attr, attrs[attr]);
          }
        }
      }
      if (html) e.innerHTML = html;
      return e;
    }

    function hmcAlert(m, v = false) {
      if (settings.debug) {
        if (v) {
          //alert(getLocaleText(m, v));
        } else {
          //alert(getLocaleText(m));
        }
      }
    }

    function checkScreenSize() {
      screenResize();
    }

    function screenResize() {
      var w = window.innerWidth > 0 ? window.innerWidth : screen.width;
      if (w <= settings.breakpoints.sm) {
        document.body.classList.add(classes.app.modal);
      } else if (document.body.classList.contains(classes.app.modal)) {
        document.body.classList.remove(classes.app.modal);
      }
    }

    function getLocaleText(m, v = false, q) {
      var checkNumber = false;
      var bigNum = false;
      if (v) {
        for (const c in v) {
          if (c == "number") {
            checkNumber = true;
            if (parseInt(v[c]) > 1) bigNum = true;
          }
        }
        if (checkNumber) {
          /*
          if (typeof m === "string") {
            return m.supplant(v);
          }*/
          if (bigNum) {
            if (q.minSelectedChoices > 1) {
              return getTranslation(m + ".a").supplant(v);
            }
            return getTranslation(m + ".p").supplant(v);
          }
          return getTranslation(m + ".s").supplant(v);
        } else {
          return getTranslation(m + ".p").supplant(v);
        }
      } else {
        return m;
      }
    }

    String.prototype.supplant = function (o) {
      return this.replace(/{([^{}]*)}/g, function (a, b) {
        var r = o[b];
        return typeof r === "string" || typeof r === "number" ? r : a;
      });
    };

    function dataLayerPush(action = null, params = {}) {
      if (typeof dataLayer !== "undefined" && action !== null) {
        dataLayer.push(dataLayerObjectPopulator(action, params));
      }
    }

    function dataLayerObjectPopulator(action = null, params = {}) {
      var obj = {};
      if (action !== null) {
        obj.event = tagging.event.name;
        obj.eventCategory = tagging.event.category;
        obj.eventAction = action;
        if ("step" in params) {
          (obj.step = params.step.toString()),
            (obj.question = settings.questionsMap[params.question][node.TITLE]),
            (obj.answers = dataLayerAnswersPopulator(
              params.question,
              params.answers
            ));
        } else if ("label" in params) {
          obj.eventLabel = params.label.join(",");
        }
      }
      return obj;
    }

    function dataLayerAnswersPopulator(question, answers) {
      var result = [];
      answers.forEach((answer) => {
        result.push(settings.questionsMap[question].answers[answer]);
      });
      return result.join("|");
    }

    _hmcObject.goToPage = function (n, p = 0) {
      goToPage(n, p);
    };

    _hmcObject.debug = function (b) {
      if (typeof b === type.BOOLEAN) {
        settings.debug = b;
      } else if (b !== undefined) {
        console.error(errorsMsg.BOOLEAN_EXPECTED);
      }
      return settings.debug;
    };

    _hmcObject.log = function (m, s = false) {
      log(m, s);
    };

    _hmcObject.restartHMC = function () {
      restartHMC();
    };

    _hmcObject.renderResults = function (url = false) {
      renderResults(url);
    };

    // Change a hmcData property
    _hmcObject.Model = function (model = false) {
      if (model) {
        settings.form = model;
        initHMC();
      }
      return settings;
    };

    _hmcObject.Create = function (o = {}) {
      if (isSmartedit()) {
        log("[HMC] This is smartedit!", false, true);
        return false;
      }
      loadingSpinnerOn();
      initSettings(o);
      log("[HMC] Initializing...!!", false, true);
      if (o.model) {
        settings.form = o.model;
        log("[HMC] JSON data from DOM", loggerStyle.force.info, true);
        initHMC();
      } else if (o.key) {
        log("[HMC] JSON data from web", false, true);
        settings.form = getJsonData(o.key);
        var checkExist = setInterval(function () {
          log("[HMC] Loading JSON data...", false, true);
          if (!isEmptyObj(settings.form)) {
            log("[HMC] JSON data successfully loaded!", false, true);
            initHMC();
            clearInterval(checkExist);
          }
        }, 100); // check every 100ms
      }
      return settings;
    };

    function initSettings(o) {
      settings.debug = o.debug ? o.debug : false;
      settings.themeLight = o.themeLight ? o.themeLight : false;
      settings.hmc.name = o.name ? o.name : false;
      settings.hmc.json.modelUrl = o.modelUrl ? o.modelUrl : false;
      settings.navigationLight = settings.themeLight;
      if ("navigationLight" in o)
        settings.navigationLight = o.navigationLight ? true : false;

      if (o.brand) {
        switch (o.brand) {
          case BRAND.kenwood:
            settings.brand = o.brand;
            settings.registrationForm =
              "registationForm" in o ? o.registationForm : true;
            break;
          case BRAND.delonghi:
            settings.brand = o.brand;
            settings.navigationDL = true;
            settings.themeLight = true;
            settings.navigationLight = true;
            break;
          case BRAND.braun:
            settings.brand = o.brand;
            settings.navigationDL = true;
            settings.themeLight = true;
            settings.navigationLight = true;
          default:
            //alert(errorsMsg.GENERAL);
            break;
        }
      }
      if (o.locale) {
        settings.locale = o.locale.replace("-", "_");
      } else {
        settings.locale = location.pathname.split("/")[1].replace("-", "_");
      }
    }

    async function initHMC() {
      log("[HMC] initHMC", false, true);
      logTimer("initHMC");
      let retranslations = await getTexts();
      settings.debug = getBooleanStorefront("hmc.debug");
      settings.configurator = getBooleanStorefront("hmc.configurator");
      settings.registrationForm = getBooleanStorefront("hmc.registration.form");
      settings.landingPopUp = getBooleanStorefront("hmc.landing.popup");
      window.addEventListener("resize", screenResize);
      checkScreenSize();
      builder();
    }

    // Change a hmcData property
    const getPages = () => {
      settings.lastPage = settings.form[node.PAGES].length;
      return settings.form[node.PAGES];
    };

    _hmcObject.getCurrentPage = function () {
      return settings.lastPage;
    };

    const scrollToTop = (height = 0) => {
      window.scrollTo({ top: height, behavior: "smooth" });
    };

    const getAppHeight = () => {
      return settings.app.wrapper.offsetTop;
    };

    const loadingSpinnerOn = () => {
      loadingSpinner(true);
    };

    const loadingSpinnerOff = () => {
      loadingSpinner(false);
    };

    const loadingSpinner = (e = true) => {
      if (!isSmartedit()) {
        var checkExist = setInterval(function () {
          let spinner = document.querySelector("." + classes.spinner.element);
          if (spinner) {
            e
              ? addClass(spinner, classes.spinner.visible)
              : removeClass(spinner, classes.spinner.visible);
            clearInterval(checkExist);
          }
        }, 100); // check every 100ms
      }
    };

    _hmcObject.scrollToTop = scrollToTop;

    return _hmcObject;
  }

  // We need that our library is globally accesible, then we save in the window
  if (typeof window.DlgHMC === "undefined") {
    window.DlgHMC = DlgHMC();
  }
})(window);
